import React from "react";
import { View } from "react-native";

import ValueDashSimplified from "app/views/ValueDashSimplified";

export default class ValueView extends React.Component {
  render() {
    return (
      <View style={{ flex: 1 }}>
        <ValueDashSimplified {...this.props} />
      </View>
    );
  }
}
